[
  { "label": "Unpaid", "id": "urn:li:seniority:1" },
  { "label": "Training", "id": "urn:li:seniority:2" },
  { "label": "Entry", "id": "urn:li:seniority:3" },
  { "label": "Senior", "id": "urn:li:seniority:4" },
  { "label": "Manager", "id": "urn:li:seniority:5" },
  { "label": "Director", "id": "urn:li:seniority:6" },
  { "label": "VP", "id": "urn:li:seniority:7" },
  { "label": "CXO", "id": "urn:li:seniority:8" },
  { "label": "Partner", "id": "urn:li:seniority:9" },
  { "label": "Owner", "id": "urn:li:seniority:10" }
]
